import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { HeaderComponent } from "@components/header/header.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { ModalComponentMediator } from "~app/common/components/modal/modal-component-mediator";
import { ITypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { CommandControlBinder } from "~app/common/services/cqs/command-control-binder/command-control-binder";
import { CommandService } from "~app/common/services/cqs/command.service";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { CreateLeverantorsorderCommand } from "../commands/CreateLeverantorsorderCommand";
import { LeverantorsorderradCreateComponent } from "../leverantorsorder-details/leverantorsorderrad-create/leverantorsorderrad-create.component";
import { LeverantorsorderDetailRequestDTO } from "../models/LeverantorsorderDetailRequestDTO";
import { LeverantorsorderradDTO } from "../models/LeverantorsorderradDTO";
import { ILeverantorsorderDetail } from "../models/leverantorsorder-detail-model";
import { LeverantorsorderService } from "../services/leverantorsorder.service";
import { LeverantorsorderValidation } from "./leverantorsorder.validation";

@Component({
    selector: "rask-create-leverantorsorder-modal",
    templateUrl: "./create-leverantorsorder-modal.component.html",
    styleUrls: ["./create-leverantorsorder-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        SelectorComponent,
        RadiobuttonGroupComponent,
        HeaderComponent,
        LeverantorsorderradCreateComponent,
        SaveButtonComponent,
        TranslatePipe,
        ButtonComponent
    ]
})
export class CreateLeverantorsorderModalComponent implements OnInit {
    command: CreateLeverantorsorderCommand;
    form: UntypedFormGroup;
    levorder: ILeverantorsorderDetail;
    levorderrad: LeverantorsorderradDTO;
    statusButtons = [
        { key: "Kontrakt",
            value: "Kontrakt" },
        { key: "Prognos",
            value: "Prognos" }
    ];
    validaitonContext: IValidationContext;
    validation: IValidationScope;

    private readonly busyService = inject(BusyService);
    private readonly commandService = inject(CommandService);
    private readonly formBinder = inject(FormBinderService);
    private readonly leverantorsorderService = inject(LeverantorsorderService);
    private readonly modalComponentMediator = inject(ModalComponentMediator);
    private readonly translationService = inject(TranslateService);

    attachOrderrad() {
        this.command.handelssortimentsgruppId = this.levorderrad.handelssortimentsgrupp.id;
        this.command.kvantitet = this.levorderrad.kvantitet;
        this.command.mattslag = this.levorderrad.mattslag;
        this.command.periodFrom = this.levorderrad.periodFrom.toString();
        this.command.periodTom = this.levorderrad.periodTom.toString();
        this.command.egenBefraktning = this.levorderrad.egenBefraktning;
    }

    bindControlToCommand() {
        const binder = new CommandControlBinder(null, this.commandService, CreateLeverantorsorderCommand);
        const ctrls = this.form.controls;
        binder.bindControl(ctrls.leverantor, (v, c) => c.leverantorId = v?.id);
        binder.bindControl(ctrls.status, "status");
        binder.onUpdate.subscribe(c => this.command = c);
    }

    canSave() {
        return !this.form.invalid;
    }

    close() {
        this.modalComponentMediator.getRef().close(null);
    }

    initValidation(): void {
        this.validaitonContext = LeverantorsorderValidation.init(this.translationService, this.levorder as any as LeverantorsorderDetailRequestDTO);
        this.validation = this.validaitonContext.current;
        this.formBinder.attachValidation(this.validation, this.form);
    }

    leverantorViewFormatter = (v: ITypeAheadResult) => v.namn;

    ngOnInit(): void {
        this.levorder = new LeverantorsorderDetailRequestDTO() as any;
        this.levorder.status = this.statusButtons[0].key;
        this.form = this.formBinder.CreateGroup(this.levorder);
        this.initValidation();
        this.bindControlToCommand();
    }

    onModelCreated(model) {
        this.levorderrad = model;
    }

    save() {
        this.attachOrderrad();
        this.busyService.addWork(this.commandService.pushCommandQueueTransaction()).subscribe(() => {
            this.close();
        });
    }

    searchLeverantor = (str: string) => this.leverantorsorderService.searchForLeverantorTypeAhead({ query: str });
}
